import React, {PureComponent} from "react"
import {Modal} from "react-bootstrap"

import Button from "@irati/ui/src/Button"
import {H2} from "@irati/ui/src//Typography/Heading"
import {isPromise} from "@irati/utils/promise"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Loading from "@irati/ui/src/Loading"

import {Hr} from "@irati/ui/src/Layout"

interface Props {
  cancelButtonText?: string,
  buttonText: string,
  load?: Promise<void>,
  onCancel: () => void,
  onSubmit: () => Promise<void>,
  open?: boolean | undefined,
  text: string
}

interface State {
  open: boolean | undefined
}

export default class AreYouSurePopUp extends PureComponent<Props, State> {
  static defaultProps = {
    cancelButtonText: null,
    load: null,
    onCancel: () => undefined,
    open: false
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      open: props.open
    }
  }

  toggle = () => {
    this.setState({open: !this.state.open})
  };

  handleSubmit = () => {
    const submit = this.props.onSubmit()
    if (isPromise(submit)) {
      submit.then(() => this.toggle())
    } else {
      this.toggle()
    }
  }

  handleCancel = () => {
    this.props.onCancel()
    this.toggle()
  }

  render() {
    const {open} = this.state
    const {text, load, buttonText, cancelButtonText} = this.props

    return (
      <>
        <Modal
          dialogClassName="areYouSurePopUp"
          show={open}
          onHide={this.handleCancel}>
          <Flex direction="column" padding={4}>
            <H2>{text}</H2>
            <Hr />
            <Flex justifyContent="flex-end" alignItems="center">
              <Button tertiary onClick={this.handleCancel} marginRight id="admin_areYouSure_button_cancel">
                {cancelButtonText || <FormattedMessage id="platform.components.areYouSurePopUp.button.cancel" />}
              </Button>
              <Loading load={load} useLoader={false} />
              <Button primary load={load} onClick={this.handleSubmit} id="admin_areYouSure_button_submit">
                {buttonText}
              </Button>
            </Flex>
          </Flex>
        </Modal>
      </>
    )
  }
}
